import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Image } from 'foundations-components/transitional/components/Image';
import { Link } from 'foundations-components/transitional/components/Link';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { useState } from 'react';
import { ListingActionMenu } from '../ListingActionMenu';
import { translateProductType } from '../utils/translateProductType';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EcosystemListingStub({
  actions = [],
  imageSrc,
  installed = false,
  listingHref,
  name,
  onActionClick = () => {},
  productType,
  providerName
}) {
  const [isHovered, setIsHovered] = useState(false);
  return /*#__PURE__*/_jsxs(Flex, {
    inlineSize: "100%",
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    children: [/*#__PURE__*/_jsx(Link, {
      href: listingHref,
      use: "unstyled",
      children: /*#__PURE__*/_jsxs(Flex, {
        gap: "400",
        children: [/*#__PURE__*/_jsx(Image, {
          alt: name,
          blockSize: "40px",
          inlineSize: "40px",
          objectFit: "cover",
          src: imageSrc
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h5",
            children: name
          }), /*#__PURE__*/_jsx(Text, {
            as: "small",
            color: "text-core-subtle",
            marginBlockStart: "50",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "trellisEcosystem.listingStub.subtitle",
              options: {
                productType: translateProductType(productType),
                providerName
              }
            })
          }), installed && /*#__PURE__*/_jsx(StatusTag, {
            marginBlockStart: "100",
            use: "success",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "trellisEcosystem.listingStub.installed"
            })
          })]
        })]
      })
    }), actions.length > 0 && /*#__PURE__*/_jsx(View, {
      marginInlineStart: "auto",
      children: isHovered ? /*#__PURE__*/_jsx(ListingActionMenu, {
        actions: actions,
        onActionClick: onActionClick
      }) :
      /*#__PURE__*/
      // placeholder for the action menu icon
      _jsx(View, {
        blockSize: "32px",
        inlineSize: "32px"
      })
    })]
  });
}